import { useTradeSalesStore } from "@fero/stores";
import { Grid } from "@mui/material";
import type { PurchaseRequestSalePriceType } from "adl-gen/ferovinum/app/db";
import { BaseWizardCard } from "components/library/widgets/wizard-card/base-wizard-card";
import { RadioGroup } from "components/widgets/inputs/radio-group/radio-group";

interface SalePriceTypeSelectorCardProps {
  salePrice: PurchaseRequestSalePriceType;
  onChange: (salePriceType: PurchaseRequestSalePriceType) => void;
}

type SalePriceType = {
  value: PurchaseRequestSalePriceType;
  label: string;
};

export const SalePriceTypeSelectorCard = ({
  salePrice,
  onChange,
}: SalePriceTypeSelectorCardProps) => {
  const { options } = useTradeSalesStore();
  const salePriceTypes: (SalePriceType & { disabled?: boolean })[] = [
    {
      value: "incDutyExVat",
      label: "Inclusive of duty, exclusive of VAT",
      disabled: options.isEditMode,
    },
    {
      value: "incDutyAndVat",
      label: "Inclusive of duty, inclusive of VAT",
      disabled: options.isEditMode,
    },
    {
      value: "exDutyAndVat",
      label: "Exclusive of duty, exclusive of VAT",
      disabled: options.isEditMode,
    },
  ];
  return (
    <BaseWizardCard
      title={"Sale Price Selection"}
      subtitle={"Does the sale price you are entering include or exclude duty?"}
      inputElement={
        <Grid container spacing={0}>
          <RadioGroup
            options={salePriceTypes}
            value={salePrice}
            onChange={(newSalePriceType) =>
              onChange(newSalePriceType as PurchaseRequestSalePriceType)
            }
          />
        </Grid>
      }
    />
  );
};
